import { DEFAULT_FILL_COLOR, DEFAULT_STROKE_COLOR } from "../constants";

const migrateToV1 = (currentData, data) => {
    let newData = {
        name: currentData.name ? currentData.name : data.name,
        elements: migratePlantsToV1(currentData.plants?.length ? currentData.plants : data.plants).concat(migrateShapesToV1(currentData.shapes?.length ? currentData.shapes : data.shapes)),
        settings: Object.keys(currentData.settings || {}).length ? currentData.settings : data.settings,
        view: migrateViewToV1(Object.keys(currentData.view || {}).length ? currentData.view : data.view),
        species: Object.keys(currentData.species || {}).length ? currentData.species : data.species,
        showMigrationMessage: true,
    }
    if (!newData.settings.name) {
        newData.settings.name = newData.name;
    }
    return newData;
}

const migratePlantsToV1 = (plants = []) => {
    return plants.map((plant) => {
        let label = plant.label;
        return {
            type: 'ellipse',
            data: {
                x: plant.x,
                y: plant.y,
                width: plant.size * 100,
                height: plant.size * 100,
                labels: label && label != '' ? [label] : [],
                labelX: 0,
                labelY: 0,
                fillColor: DEFAULT_FILL_COLOR,
                strokeColor: null,
                strokeWidth: null,
            },
            speciesIds: [plant.plant_id],
        };
    });
}

const migrateShapesToV1 = (shapes = []) => {
    return shapes.map((shape) => {
        let label = shape.data.label;
        return {
            type: shape.type,
            data: Object.assign(
                shape.data,
                {
                    fillColor: null,
                    strokeColor: DEFAULT_STROKE_COLOR,
                    strokeWidth: null,
                },
                {
                    labels: label && label != '' ? [label] : [],
                    labelX: 0,
                    labelY: 0,
                }
            ),
            speciesIds: [],
        };
    });
}

const migrateViewToV1 = (view = {}) => {
    return view.zoomLevel == undefined
        ? {}
        : {
            scale: 1.2 ** view.zoomLevel,
            posX: view.posX,
            posY: view.posY,
        }
}

export { migrateToV1 };
